// GENERATED by generateConfigRelease.js — do not edit.
// Client id handed to the PayPal JS SDK in CartModal. Switch environments by
// rebuilding: `npm run build-testing` or `npm run build-release`.

export const PAYPAL_CLIENT_ID = "AXceADuqlLXB6peN9TeEUY-dIc0Zf5cPWi1hVwoEUmdb5EC3pMtWjhk05X7FgVx9RLxVwpvqSXtY15li";
export const PAYPAL_ENV: "live" | "sandbox" = "live";
